import React from "react"

import CollapsibleContainer from "components/CollapsibleContainer"

import PackageParents from "./Parents"
import PackageStudents from "./Students"

const PrepaidHoursTracking = () => {
  return (
    <>
      <CollapsibleContainer title={<h4 className="my-2">Student-Purchased</h4>}>
        <PackageStudents />
      </CollapsibleContainer>
      <CollapsibleContainer title={<h4 className="my-2">Parent-Purchased</h4>}>
        <PackageParents />
      </CollapsibleContainer>
    </>
  )
}

export default PrepaidHoursTracking
